import React from 'react'
import styled from 'styled-components'
import CheckBox from '../CheckBox/CheckBox'

const StyledCheckBox = styled(CheckBox)`
  min-width: 200px;
  font-size: 14px;
  border: 1px solid purple;
`

const AmenityCheckBox = ({onSelect, value, idx, checked, label}) => {
  const onCheckChange = checked => {
    onSelect({value, checked})
  }

  return (
    <StyledCheckBox
      key={idx}
      index={idx}
      onSelect={onCheckChange}
      checked={checked}
      value={value}
      label={label}
      onChange={(idx, checked) => {
        onCheckChange(checked)
      }}
    />
  )
}

export default AmenityCheckBox
